// extracted by mini-css-extract-plugin
export default {"defaultWrapper":"_0i-iQ","outerWrapper":"F-uvp","innerWrapper":"eKa2s","illustration":"wFVR9","startSpleisButton":"mn-yG","title":"_3No+z"};